export default __webpack_public_path__ + "static/media/330_store01-fr-mobile.10c76425.png";